export default "__VITE_ASSET__CLAUbK2Q__"